import { render, staticRenderFns } from "./TopBarAdminMenu.vue?vue&type=template&id=5c6ecebd&"
import script from "./TopBarAdminMenu.vue?vue&type=script&lang=ts&"
export * from "./TopBarAdminMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6ecebd')) {
      api.createRecord('5c6ecebd', component.options)
    } else {
      api.reload('5c6ecebd', component.options)
    }
    module.hot.accept("./TopBarAdminMenu.vue?vue&type=template&id=5c6ecebd&", function () {
      api.rerender('5c6ecebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/TopBarAdminMenu.vue"
export default component.exports